import {  FormControl, FormHelperText, InputLabel, MenuItem, Select, Stack, Typography } from '@mui/material'
import { FunctionComponent} from 'react'
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { IUserDetails } from '../../../../shared/services/user-details/user-details.model';
import { DialogWrapper } from '../../../presentation-components/display-elements-components/dialog-wrapper';

export const DeactivateUserDialog: FunctionComponent<{
  open: boolean,
  closeHandler: () => void,
  users: IUserDetails[],
  userId: string,
  submitHandler: (userId: string, newUserId: string | null) => void,
  isSubmitting: boolean,
}> = ({
  open,
  closeHandler, users, userId, submitHandler, isSubmitting }) => {

    const deactivateUserSchema = Yup.object().shape({
      newAssignedUserId: Yup.string().required('You must select a user to reassign the tasks to')
    })

    const formik = useFormik({
      initialValues: {
        newAssignedUserId: null,
      },
      validationSchema: deactivateUserSchema,
      onSubmit: (values) => {
        submitHandler(userId, values.newAssignedUserId)
      }
    });

    const cancelHandler = () => {
      formik.resetForm();
      closeHandler();
    }

    return (
      <DialogWrapper open={open} onClose={closeHandler} title="Confirmation" cancelHandler={cancelHandler} submitHandler={formik.submitForm} isSubmitting={isSubmitting}>
        <Typography variant={'body1'}>Are you sure you want to deactivate this user?</Typography>
        <Stack sx={{ mt: 2 }}>
          <Typography variant='body1' sx={{ mb: 1 }}>All outstanding and upcoming tasks will need to be reassigned to another user, Please select which user to reassign the tasks too</Typography>
          <FormControl fullWidth variant='outlined'>
            <InputLabel>User</InputLabel>
            <Select
              id='newAssignedUserId' name='newAssignedUserId'
              value={formik.values.newAssignedUserId}
              onChange={formik.handleChange}
              label='User'
              error={formik.touched.newAssignedUserId && Boolean(formik.errors.newAssignedUserId)}
              fullWidth>
              {users.filter(u => u.id !== userId).sort((a, b) => a.firstName.localeCompare(b.firstName)).map((user, index) => (
                <MenuItem key={index}
                  value={user.id}>{`${user.firstName} ${user.surname}`}</MenuItem>
              ))}
            </Select>
            {formik.touched.newAssignedUserId && formik.errors.newAssignedUserId &&
              <FormHelperText sx={{ color: "#bf3333", marginLeft: "16px !important" }}>
                {formik.errors.newAssignedUserId ? <div>{formik.errors.newAssignedUserId as string}</div> : null}
              </FormHelperText>
            }
          </FormControl>
        </Stack>
      </DialogWrapper>
    )
  }